export default {
  // auth
  LOGIN: "admin/login",
  REGISTER_USER: "admin/register",
  // user
  USER_LIST: "admin/user/list",
  USER_EDIT: "admin/user/update/",
  USER_MONEY: "admin/user/add-subtract-money/",
  BLOCK_WITHDRAW: "admin/block-withdraw",
  BLOCK_ORDER: "admin/block-order",

  // product
  PRODUCT_LIST: "admin/product/list",
  PRODUCT_UPDATE: "admin/product/update/",
  PRODUCT_RESULT: "admin/product/result",

  // transaction
  TRANSACTION_LIST: "admin/transaction/list",
  TRANSACTION_APPROVAL: "admin/transaction/approve",
  
  // order
  ORDER_LIST: "admin/order/list",
  ORDER_SET_RESULT: "admin/order/result/",

  // SystemConfig
  SYSTEM_CONFIG: "admin/system-config",

  USER_DELETE: "admin/user"
};
